import React, { useState, useEffect, useRef } from "react";
import Image from "components/Elements/Image/Image.tsx";
import Branding from "../Branding.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import parse from "html-react-parser";
import {
  languageListObjects,
  languagesList,
  languageShortList,
} from "utils/jumbomailSettings.js";
import { useUser } from "contexts/userContext/userContext.js";
import Dropdown from "components/Elements/Dropdown/Dropdown.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import { Toggle } from "components/Elements/Toggle/Toggle.js";

const DesignOption = ({
  singleOrRotate,
  setSingleOrRotate,
  backgroundImagesList,
  setBackgroundImagesList,
  FullDetailsEmbedPage,
  diractionPage,
  setDiractionPage,
  setBrandingColor,
  brandingColor,
  setTempBrandingColor,
  isDefaultBackgrounds,
  updateDesign,
  setIsOpen,
  setTypeOfSettings,
  setHideSidePanel,
  pageLanguage,
  setPageLanguage,
  displayFormDetialsDB,
  setDisplayFormDetialsDB,
  displaySidePanel,
  setDisplaySidePanel,
}) => {
  const { setModal } = useModal();
  const { isSubscribed } = useUser();
  const colorTextRef = useRef();
  const colorInputRef = useRef();
  const [clickOnColorInput, setClickOnColorInput] = useState(false);

  const convertLanguage = (shortLang) => {
    //get the language from the short language and convert to the full language
    const lang = languageListObjects.find((item) => item.code === shortLang);
    return lang.title;
  };
  const [titleDropDown, setTitleDropDown] = useState(
    convertLanguage(pageLanguage || "en")
  );
  const handleChange = (e, itemKey) => {
    setTitleDropDown(languagesList[itemKey]);
    setPageLanguage(languageShortList[itemKey]);
    updateDesign("language", languageShortList[itemKey]);
  };

  const closeSidePanel = () => {
    setClickOnColorInput(true);
    setHideSidePanel(true);
  };
  useOnClickOutside(colorTextRef, () => {
    if (colorText !== brandingColor) {
      const validColorCode = new RegExp("^#(?:[0-9a-fA-F]{3}){1,2}$");
      if (validColorCode.test(colorText)) {
        setColor(colorText);
        updateDesign("brandingColor", colorText);
      } else {
        addToast(getTextByKey("invalid-color-code"), {
          appearance: "error",
        });
        setColorText(color);
      }
    }
  });
  const { addToast } = useToasts();

  const { getTextByKey } = useContent();
  const [color, setColor] = useState(brandingColor);
  const [colorText, setColorText] = useState(brandingColor);
  const handleChangeBrandingColor = (e) => {
    setColor(e);
  };

  const handleChangeBrandingColorText = (e) => {
    if (e.startsWith("#")) {
      setColorText(e);
    }
  };

  useEffect(() => {
    setBrandingColor(color);
    setTempBrandingColor(color);
    setColorText(color);
  }, [color]);

  const updateDirectionEmbedPage = (direction) => {
    setDiractionPage(direction);
    updateDesign("direction", direction);
    setIsOpen(false);
    setTimeout(() => {
      setTypeOfSettings(null);
    }, 500);
  };

  const updateBackgroundImagesMode = (backgroundsMode) => {
    if (!isSubscribed()) {
      setModal(() => <EmbedLimitOptionsModal />);
    } else {
      setSingleOrRotate(backgroundsMode);
      updateDesign("singleOrRotate", backgroundsMode);
    }
  };

  useOnClickOutside(colorInputRef, () => {
    if (clickOnColorInput) {
      updateDesign("brandingColor", colorText);
      //setIsOpen(false);
      setTimeout(() => {
        setHideSidePanel(false);
        //setTypeOfSettings("design");
        //setIsOpen(true);
      }, 500);
    }
  });

  const handleClickInputColor = () => {
    closeSidePanel();
  };

  const updateDisplayFormDetails = () => {
    const displayFormDetails = !displayFormDetialsDB;
    setDisplayFormDetialsDB(displayFormDetails);
    updateDesign("displayFormDetails", displayFormDetails);
  };

  const updateDisplaySidePanelDetails =()=>{
    const displaySidePanelDetails = !displaySidePanel;
    setDisplaySidePanel(displaySidePanelDetails);
    updateDesign("displaySidePanel", displaySidePanelDetails);
  }

  return (
    <div className="design-option">
      <div className="design-option-title">
        <span className="desing-title">
          {getTextByKey("personal-design-tooltip")}
        </span>
      </div>
      <div className="page-language part">
        <div className="page-language-container">
          <div className="page-language-text-and-tooltip">
            <span className="text-language design-text">
              {getTextByKey("embedpage-language")}
            </span>
            <Tooltip
              clickable
              id={"embedpage-language"}
              tooltipTextKey={"embed-page-language-tooltip"}
              //hardPositioned
              end
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
          <div className="page-language-dropdown">
            <Dropdown
              title={titleDropDown}
              handleChange={handleChange}
              selectList={languagesList}
              defaultValue={titleDropDown}
            >
              <div className="">
                <Icon name="arrow-down-solid" small />
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="branding-color part">
        <div className="branding-color-container">
          <div className="branding-left-side">
            <span className="branding-text design-text">
              {getTextByKey("branding-color")}
            </span>
            <Tooltip
              clickable
              id={"branding-color"}
              tooltipTextKey={"embed-page-branding-color-tooltip"}
              //hardPositioned
              bottom
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
          <div className="branding-right-side">
            <div className="input-color-div">
              <div className="text-color">
                <input
                  ref={colorTextRef}
                  type="text"
                  value={colorText}
                  onChange={(e) => {
                    handleChangeBrandingColorText(e.target.value);
                  }}
                />
              </div>
              <div
                className="background-color"
                style={{ backgroundColor: color }}
              >
                <input
                  onClick={() => handleClickInputColor()}
                  ref={colorInputRef}
                  value={color}
                  onChange={(e) => handleChangeBrandingColor(e.target.value)}
                  type="color"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-diraction part">
        <div className="title">
          <span className="direction-text design-text">
            {getTextByKey("settings-embed-page-text-direction-title")}
          </span>
        </div>
        <div className="options">
          <div
            className={`option-ltr option first ${
              diractionPage === "rtl" ? "active" : ""
            }`}
            onClick={() => {
              updateDirectionEmbedPage("rtl");
            }}
          >
            <div className="image-option">
              <Image
                className="new-layout"
                name={`personal/${
                  diractionPage === "rtl" ? "left-layout-active" : "left-layout"
                }`}
                ext="svg"
                alt=""
                title=""
              />
            </div>
          </div>
          <div
            className={`option-rtl option ${
              diractionPage === "ltr" ? "active" : ""
            }`}
            onClick={() => {
              updateDirectionEmbedPage("ltr");
            }}
          >
            <div className="image-option">
              <Image
                className="new-layout"
                name={`personal/${
                  diractionPage === "ltr"
                    ? "right-layout-active"
                    : "right-layout"
                }`}
                ext="svg"
                alt=""
                title=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="display-form-details part">
        <Toggle
          status={displayFormDetialsDB}
          setStatus={updateDisplayFormDetails}
        />
        <span className="display-form-details-text">
          {getTextByKey("display-form-details-text")}
        </span>
        <Tooltip
          id="display-form-details-tooltip"
          tooltipTextKey="display-form-details-tooltip"
          end
        >
          <div className={`tootltip-icon-container`}>
            <Icon name="question-circle" iconClass="tooltip-question" />
          </div>
        </Tooltip>
      </div>
      <div className="display-form-details part">
        <Toggle
          status={displaySidePanel}
          setStatus={updateDisplaySidePanelDetails}
        />
        <span className="display-form-details-text">
          {getTextByKey("display-side-panel-details-text")}
        </span>
        <Tooltip
          id="display-side-panel-details-tooltip"
          tooltipTextKey="display-side-panel-details-tooltip"
          end
        >
          <div className={`tootltip-icon-container`}>
            <Icon name="question-circle" iconClass="tooltip-question" />
          </div>
        </Tooltip>
      </div>
      <div className="background-display part">
        <div className="title design-text">
          <span>{getTextByKey("background-display-personal-page")}</span>
        </div>
        <div className="display-radios">
          <div className="input-status-div">
            <Image
              className="input-checkbox"
              onClick={(e) => {
                updateBackgroundImagesMode("Single");
              }}
              name={
                singleOrRotate === "Single"
                  ? "radio-checked"
                  : "radio-unchecked"
              }
              ext="svg"
            />
            <span className="input-label">
              {getTextByKey("background-single-mode-embed-page")}
            </span>{" "}
            <Tooltip
              clickable
              id={"background-display-single"}
              tooltipTextKey={"personal-background-display-single-tooltip"}
              //hardPositioned
              bottom
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
          <div className="input-status-div">
            <Image
              className="input-checkbox"
              onClick={(e) => {
                updateBackgroundImagesMode("Random");
              }}
              name={
                singleOrRotate === "Random"
                  ? "radio-checked"
                  : "radio-unchecked"
              }
              ext="svg"
            />
            <span className="input-label">
              {getTextByKey("rotate-background-mode-embed-page")}
            </span>{" "}
            <Tooltip
              clickable
              id={"background-display-random"}
              tooltipText={parse(
                getTextByKey("personal-background-display-random-tooltip")
              )}
              //hardPositioned
              bottom
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
      </div>

      <div className="upload-images part">
        <Branding
          isDefaultBackgrounds={isDefaultBackgrounds}
          singleOrRotate={singleOrRotate}
          FullDetailsEmbedPage={FullDetailsEmbedPage}
          setBackgroundImagesList={setBackgroundImagesList}
          backgroundImagesList={backgroundImagesList}
        />
      </div>
    </div>
  );
};

export default DesignOption;
